import { useState, useEffect } from "react";

interface MobileDetection {
  isMobile: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isTouchDevice: boolean;
  isStandalone: boolean;
}

export function useMobileDetection(): MobileDetection {
  const [detection, setDetection] = useState<MobileDetection>({
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isTouchDevice: false,
    isStandalone: false,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    setDetection({
      isMobile,
      isIOS,
      isAndroid,
      isTouchDevice,
      isStandalone,
    });
  }, []);

  return detection;
}
